import React, {useState} from 'react';
import {IMaskMixin} from 'react-imask';
import {IconButton, InputAdornment} from '@material-ui/core';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {MaskedPattern} from 'imask';
import InputText from './InputText';

const mask = new MaskedPattern({mask: '{000-00-0000}'});

const MaskedInput = IMaskMixin(({inputRef, ...props}) => {
    const [itype, setItype] = useState('password');
    return (
        <InputText
            {...(props as any)}
            InputLabelProps={{shrink: true}}
            ref={inputRef}
            {...((props as any).showHideButton && {
                type: itype,
                InputProps: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle SSN visibility"
                                onClick={() => setItype((prev) => (prev === 'text' ? 'password' : 'text'))}
                                edge="end"
                            >
                                {itype === 'text' ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            })}
        />
    );
});

const InputSsn = (props: any) => {
    return (
        <MaskedInput
            mask={mask}
            label={props.label}
            value={props.value}
            onAccept={(maskedValue: any) => {
                const digitValue = maskedValue.replace(/\D/g, '');
                props?.onChange(digitValue);
            }}
            placeholder="123-45-6789"
            {...(props['aria-label'] && {'aria-label': props['aria-label']})}
            {...(props.disabled && {disabled: props.disabled})}
            {...(props.error && {error: props.error})}
            {...(props.showHideButton && {showHideButton: true})}
            {...(props.classes && {classes: props.classes})}
        />
    );
};

export default InputSsn;
